// // src/components/AboutPreview.jsx
// import React from 'react';

// // Image – adjust path if needed
// import Book15 from '../Images/new1.jpg';

// import { theme } from '../utils/constants';

// export default function AboutPreview({ navigateTo }) {
//   return (
//     <section style={{ padding: '6rem 24px', background: theme.bgLight }}>
//       <div
//         style={{
//           maxWidth: '1280px',
//           margin: '0 auto',
//           display: 'grid',
//           gridTemplateColumns: 'repeat(auto-fit, minmax(340px, 1fr))',
//           gap: '4rem',
//           alignItems: 'center'
//         }}
//       >
//         <div style={{ borderRadius: '16px', overflow: 'hidden', boxShadow: theme.shadowMd }}>
//           <img
//             src={Book15}
//             alt="Author"
//             style={{ width: '100%', height: 'auto', display: 'block' }}
//           />
//         </div>

//         <div>
//           <h3
//             style={{
//               fontSize: '2.2rem',
//               marginBottom: '1.5rem',
//               fontFamily: "'Roboto Slab', serif"
//             }}
//           >
//             Here for you!
//           </h3>

//           <p style={{ marginBottom: '1.5rem', color: theme.textLight, lineHeight: 1.8 }}>
//             Using storage . Expert packing . simplified coordination of deliveries.
//           </p>

//           <p style={{ marginBottom: '2rem', color: theme.textLight, lineHeight: 1.8 }}>
//             We guarantee dependable and effective order fullfillment with complete loggistics controll and transparent pricing structure.
//           </p>

//           <button
//             onClick={() => navigateTo('shop')}
//             style={{
//               background: theme.primary,
//               color: 'white',
//               border: 'none',
//               padding: '0.9rem 2.2rem',
//               borderRadius: '50px',
//               fontWeight: 500,
//               cursor: 'pointer'
//             }}
//           >
//             Order Now
//           </button>
//         </div>
//       </div>
//     </section>
//   );
// }


// src/components/AboutPreview.jsx

import React from "react";
import { FiCheckCircle, FiPackage, FiTruck } from "react-icons/fi";
import Book15 from "../Images/new1.jpg";
import { theme } from "../utils/constants";

export default function AboutPreview({ navigateTo }) {
  const features = [
    {
      icon: <FiPackage size={20} />,
      title: "Carefully Packed",
      text: "Every order is prepared with care to ensure your items arrive safely.",
    },
    {
      icon: <FiTruck size={20} />,
      title: "Reliable Delivery",
      text: "Fast and dependable shipping with transparent delivery charges.",
    },
    {
      icon: <FiCheckCircle size={20} />,
      title: "Shop with Confidence",
      text: "Friendly customer support and a clear returns policy for peace of mind.",
    },
  ];

  return (
    <section
      style={{
        padding: "7rem 24px",
        background: theme.bgLight,
      }}
    >
      <div
        style={{
          maxWidth: "1280px",
          margin: "0 auto",
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit,minmax(420px,1fr))",
          gap: "5rem",
          alignItems: "center",
        }}
      >
        {/* Image */}

        <div
          style={{
            position: "relative",
          }}
        >
          <img
            src={Book15}
            alt="Upendo Store"
            style={{
              width: "100%",
              borderRadius: "24px",
              display: "block",
              boxShadow: "0 30px 60px rgba(0,0,0,.12)",
            }}
          />

          <div
            style={{
              position: "absolute",
              bottom: "24px",
              left: "24px",
              background: "rgba(255,255,255,.95)",
              backdropFilter: "blur(10px)",
              padding: "1rem 1.4rem",
              borderRadius: "14px",
              boxShadow: "0 10px 25px rgba(0,0,0,.08)",
            }}
          >
            <div
              style={{
                fontWeight: 700,
                color: theme.primary,
              }}
            >
              Trusted by shoppers worldwide
            </div>

            <small style={{ color: "#666" }}>
              Books • Gifts • Accessories
            </small>
          </div>
        </div>

        {/* Content */}

        <div>
          <span
            style={{
              display: "inline-block",
              background: "#FFF3E8",
              color: theme.primary,
              padding: ".45rem 1rem",
              borderRadius: "999px",
              fontWeight: 600,
              marginBottom: "1.25rem",
              fontSize: ".9rem",
            }}
          >
            Why Choose Upendo Store
          </span>

          <h2
            style={{
              fontFamily: "'Roboto Slab', serif",
              fontSize: "2.8rem",
              lineHeight: 1.2,
              color: theme.text,
              marginBottom: "1.5rem",
            }}
          >
            More than an online store —
            <br />
            a shopping experience you can trust.
          </h2>

          <p
            style={{
              color: theme.textLight,
              fontSize: "1.08rem",
              lineHeight: 1.9,
              marginBottom: "2.5rem",
              maxWidth: "560px",
            }}
          >
            From inspiring books to thoughtfully selected accessories,
            Upendo Store makes shopping simple. We combine careful order
            preparation, dependable delivery, and responsive customer support
            so you can shop with confidence every time.
          </p>

          <div
            style={{
              display: "grid",
              gap: "1.3rem",
              marginBottom: "2.8rem",
            }}
          >
            {features.map((feature) => (
              <div
                key={feature.title}
                style={{
                  display: "flex",
                  gap: "1rem",
                  alignItems: "flex-start",
                }}
              >
                <div
                  style={{
                    width: "48px",
                    height: "48px",
                    borderRadius: "14px",
                    background: `${theme.primary}15`,
                    color: theme.primary,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                  }}
                >
                  {feature.icon}
                </div>

                <div>
                  <h4
                    style={{
                      margin: 0,
                      marginBottom: ".35rem",
                      color: theme.text,
                    }}
                  >
                    {feature.title}
                  </h4>

                  <p
                    style={{
                      margin: 0,
                      color: theme.textLight,
                      lineHeight: 1.7,
                    }}
                  >
                    {feature.text}
                  </p>
                </div>
              </div>
            ))}
          </div>

          <button
            onClick={() => navigateTo("shop")}
            style={{
              background: theme.primary,
              color: "#fff",
              border: "none",
              padding: "1rem 2.4rem",
              borderRadius: "999px",
              fontSize: "1rem",
              fontWeight: 600,
              cursor: "pointer",
              boxShadow: "0 12px 30px rgba(0,0,0,.15)",
              transition: "all .3s",
            }}
          >
            Explore Our Collection →
          </button>
        </div>
      </div>
    </section>
  );
}